[
  {
    "code": "HT",
    "postalCode": "RH",
    "alpha3": "HTI",
    "iso3166_numeric": "332",
    "currency": "HTG",
    "timezone": "America/Port-au-Prince",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ES",
    "postalCode": "",
    "alpha3": "ESP",
    "iso3166_numeric": "724",
    "currency": "EUR",
    "timezone": "Europe/Madrid",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY_STATE",
    "EUMemberAsOf": "1986-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BR",
    "postalCode": "BR",
    "alpha3": "BRA",
    "iso3166_numeric": "076",
    "currency": "BRL",
    "timezone": "America/Sao_Paulo",
    "zipFormat": "FORMAT_BR",
    "cityFormat": "ZIP_CITY_STATE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AU",
    "postalCode": "AUS",
    "alpha3": "AUS",
    "iso3166_numeric": "036",
    "currency": "AUD",
    "timezone": null,
    "zipFormat": "NUMERIC_4",
    "cityFormat": "CITY_STATE_ZIP",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "FI",
    "postalCode": "FIN",
    "alpha3": "FIN",
    "iso3166_numeric": "246",
    "currency": "EUR",
    "timezone": "Europe/Helsinki",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1995-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ZZ",
    "postalCode": null,
    "alpha3": "ZZZ",
    "iso3166_numeric": null,
    "currency": "USD",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 1,
    "EUMemberUntil": null
  },
  {
    "code": "TF",
    "postalCode": "",
    "alpha3": "ATF",
    "iso3166_numeric": "260",
    "currency": "EUR",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PS",
    "postalCode": "PS",
    "alpha3": "PSE",
    "iso3166_numeric": "275",
    "currency": "ILS",
    "timezone": "Asia/Jerusalem",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CR",
    "postalCode": "CR",
    "alpha3": "CRI",
    "iso3166_numeric": "188",
    "currency": "CRC",
    "timezone": "America/Costa_Rica",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SY",
    "postalCode": "SYR",
    "alpha3": "SYR",
    "iso3166_numeric": "760",
    "currency": "SYP",
    "timezone": "Asia/Damascus",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PG",
    "postalCode": "PNG",
    "alpha3": "PNG",
    "iso3166_numeric": "598",
    "currency": "PGK",
    "timezone": "Pacific/Port_Moresby",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MV",
    "postalCode": "MV",
    "alpha3": "MDV",
    "iso3166_numeric": "462",
    "currency": "MVR",
    "timezone": "Indian/Maldives",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GI",
    "postalCode": "GBZ",
    "alpha3": "GIB",
    "iso3166_numeric": "292",
    "currency": "GIP",
    "timezone": "Europe/Gibraltar",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TS",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "EUR",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": "2018-01-01",
    "deactivated": 0,
    "EUMemberUntil": "2018-10-23"
  },
  {
    "code": "AT",
    "postalCode": "A",
    "alpha3": "AUT",
    "iso3166_numeric": "040",
    "currency": "EUR",
    "timezone": "Europe/Vienna",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1995-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "UZ",
    "postalCode": "UZ",
    "alpha3": "UZB",
    "iso3166_numeric": "860",
    "currency": "UZS",
    "timezone": "Asia/Tashkent",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GO",
    "postalCode": "R16",
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "XDR",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MY",
    "postalCode": "MAL",
    "alpha3": "MYS",
    "iso3166_numeric": "458",
    "currency": "MYR",
    "timezone": "Asia/Kuala_Lumpur",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SI",
    "postalCode": "SLO",
    "alpha3": "SVN",
    "iso3166_numeric": "705",
    "currency": "SIT",
    "timezone": "Europe/Ljubljana",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AS",
    "postalCode": "",
    "alpha3": "ASM",
    "iso3166_numeric": "016",
    "currency": "USD",
    "timezone": "Pacific/Pago_Pago",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CW",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "ANG",
    "timezone": null,
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KG",
    "postalCode": "KS",
    "alpha3": "KGZ",
    "iso3166_numeric": "417",
    "currency": "KGS",
    "timezone": "Asia/Bishkek",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "RS",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "RSD",
    "timezone": null,
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "OM",
    "postalCode": "OM",
    "alpha3": "OMN",
    "iso3166_numeric": "512",
    "currency": "OMR",
    "timezone": "Asia/Muscat",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "FR",
    "postalCode": "F",
    "alpha3": "FRA",
    "iso3166_numeric": "250",
    "currency": "EUR",
    "timezone": "Europe/Paris",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1957-03-25",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AM",
    "postalCode": "ARM",
    "alpha3": "ARM",
    "iso3166_numeric": "051",
    "currency": "AMD",
    "timezone": "Asia/Yerevan",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CK",
    "postalCode": "",
    "alpha3": "COK",
    "iso3166_numeric": "184",
    "currency": "NZD",
    "timezone": "Pacific/Rarotonga",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "HM",
    "postalCode": "",
    "alpha3": "HMD",
    "iso3166_numeric": "334",
    "currency": "AUD",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SR",
    "postalCode": "SME",
    "alpha3": "SUR",
    "iso3166_numeric": "740",
    "currency": "SRD",
    "timezone": "America/Paramaribo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CF",
    "postalCode": "RCA",
    "alpha3": "CAF",
    "iso3166_numeric": "140",
    "currency": "XAF",
    "timezone": "Africa/Bangui",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BH",
    "postalCode": "BRN",
    "alpha3": "BHR",
    "iso3166_numeric": "048",
    "currency": "BHD",
    "timezone": "Asia/Bahrain",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CG",
    "postalCode": "RCB",
    "alpha3": "COG",
    "iso3166_numeric": "178",
    "currency": "XAF",
    "timezone": "Africa/Brazzaville",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MA",
    "postalCode": "MA",
    "alpha3": "MAR",
    "iso3166_numeric": "504",
    "currency": "MAD",
    "timezone": "Africa/Casablanca",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "FK",
    "postalCode": "",
    "alpha3": "FLK",
    "iso3166_numeric": "238",
    "currency": "FKP",
    "timezone": "Atlantic/Stanley",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PE",
    "postalCode": "PE",
    "alpha3": "PER",
    "iso3166_numeric": "604",
    "currency": "PEN",
    "timezone": "America/Lima",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "HR",
    "postalCode": "HR",
    "alpha3": "HRV",
    "iso3166_numeric": "191",
    "currency": "HRK",
    "timezone": "Europe/Zagreb",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2013-07-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BA",
    "postalCode": "BIH",
    "alpha3": "BIH",
    "iso3166_numeric": "070",
    "currency": "BAM",
    "timezone": "Europe/Sarajevo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MX",
    "postalCode": "MEX",
    "alpha3": "MEX",
    "iso3166_numeric": "484",
    "currency": "MXN",
    "timezone": "America/Mexico_City",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "FORMAT_MX",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ML",
    "postalCode": "RMM",
    "alpha3": "MLI",
    "iso3166_numeric": "466",
    "currency": "XOF",
    "timezone": "Africa/Bamako",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MG",
    "postalCode": "RM",
    "alpha3": "MDG",
    "iso3166_numeric": "450",
    "currency": "MGA",
    "timezone": "Indian/Antananarivo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BQ",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "USD",
    "timezone": null,
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "RU",
    "postalCode": "RUS",
    "alpha3": "RUS",
    "iso3166_numeric": "643",
    "currency": "RUB",
    "timezone": "Europe/Moscow",
    "zipFormat": "NUMERIC_6",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AW",
    "postalCode": "",
    "alpha3": "ABW",
    "iso3166_numeric": "533",
    "currency": "AWG",
    "timezone": "America/Aruba",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SX",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "ANG",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CA",
    "postalCode": "CDN",
    "alpha3": "CAN",
    "iso3166_numeric": "124",
    "currency": "CAD",
    "timezone": null,
    "zipFormat": "FORMAT_CA",
    "cityFormat": "CITY_STATE_ZIP",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PH",
    "postalCode": "RP",
    "alpha3": "PHL",
    "iso3166_numeric": "608",
    "currency": "PHP",
    "timezone": "Asia/Manila",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LS",
    "postalCode": "LS",
    "alpha3": "LSO",
    "iso3166_numeric": "426",
    "currency": "LSL",
    "timezone": "Africa/Maseru",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CM",
    "postalCode": "CAM",
    "alpha3": "CMR",
    "iso3166_numeric": "120",
    "currency": "XAF",
    "timezone": "Africa/Douala",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SC",
    "postalCode": "SC",
    "alpha3": "SYC",
    "iso3166_numeric": "690",
    "currency": "SCR",
    "timezone": "Indian/Mahe",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "DO",
    "postalCode": "DOM",
    "alpha3": "DOM",
    "iso3166_numeric": "214",
    "currency": "DOP",
    "timezone": "America/Santo_Domingo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "DZ",
    "postalCode": "DZ",
    "alpha3": "DZA",
    "iso3166_numeric": "012",
    "currency": "DZD",
    "timezone": "Africa/Algiers",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NP",
    "postalCode": "NEP",
    "alpha3": "NPL",
    "iso3166_numeric": "524",
    "currency": "NPR",
    "timezone": "Asia/Katmandu",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TC",
    "postalCode": "",
    "alpha3": "TCA",
    "iso3166_numeric": "796",
    "currency": "USD",
    "timezone": "America/Grand_Turk",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CN",
    "postalCode": "RC",
    "alpha3": "CHN",
    "iso3166_numeric": "156",
    "currency": "CNY",
    "timezone": "Asia/Shanghai",
    "zipFormat": "NUMERIC_6",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PT",
    "postalCode": "P",
    "alpha3": "PRT",
    "iso3166_numeric": "620",
    "currency": "EUR",
    "timezone": "Europe/Lisbon",
    "zipFormat": "FORMAT_PR",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1986-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ZM",
    "postalCode": "Z",
    "alpha3": "ZMB",
    "iso3166_numeric": "894",
    "currency": "ZMK",
    "timezone": "Africa/Lusaka",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NR",
    "postalCode": "NAU",
    "alpha3": "NRU",
    "iso3166_numeric": "520",
    "currency": "AUD",
    "timezone": "Pacific/Nauru",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SA",
    "postalCode": "SA",
    "alpha3": "SAU",
    "iso3166_numeric": "682",
    "currency": "SAR",
    "timezone": "Asia/Riyadh",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "VE",
    "postalCode": "YV",
    "alpha3": "VEN",
    "iso3166_numeric": "862",
    "currency": "VEB",
    "timezone": "America/Caracas",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NG",
    "postalCode": "WAN",
    "alpha3": "NGA",
    "iso3166_numeric": "566",
    "currency": "NGN",
    "timezone": "Africa/Lagos",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TN",
    "postalCode": "TN",
    "alpha3": "TUN",
    "iso3166_numeric": "788",
    "currency": "TND",
    "timezone": "Africa/Tunis",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CH",
    "postalCode": "CH",
    "alpha3": "CHE",
    "iso3166_numeric": "756",
    "currency": "CHF",
    "timezone": "Europe/Zurich",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "FJ",
    "postalCode": "FJI",
    "alpha3": "FJI",
    "iso3166_numeric": "242",
    "currency": "FJD",
    "timezone": "Pacific/Fiji",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KZ",
    "postalCode": "KZ",
    "alpha3": "KAZ",
    "iso3166_numeric": "398",
    "currency": "KZT",
    "timezone": "Asia/Oral",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ZA",
    "postalCode": "ZA",
    "alpha3": "ZAF",
    "iso3166_numeric": "710",
    "currency": "ZAR",
    "timezone": "Africa/Johannesburg",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "CITY_ZIP",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SS",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "USD",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BW",
    "postalCode": "RB",
    "alpha3": "BWA",
    "iso3166_numeric": "072",
    "currency": "BWP",
    "timezone": "Africa/Gaborone",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PM",
    "postalCode": "",
    "alpha3": "SPM",
    "iso3166_numeric": "666",
    "currency": "EUR",
    "timezone": "America/Miquelon",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GU",
    "postalCode": "",
    "alpha3": "GUM",
    "iso3166_numeric": "316",
    "currency": "USD",
    "timezone": "Pacific/Guam",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LA",
    "postalCode": "LAO",
    "alpha3": "LAO",
    "iso3166_numeric": "418",
    "currency": "LAK",
    "timezone": "Asia/Vientiane",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BB",
    "postalCode": "BDS",
    "alpha3": "BRB",
    "iso3166_numeric": "052",
    "currency": "BBD",
    "timezone": "America/Barbados",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TT",
    "postalCode": "TT",
    "alpha3": "TTO",
    "iso3166_numeric": "780",
    "currency": "TTD",
    "timezone": "America/Santo_Domingo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GE",
    "postalCode": "GE",
    "alpha3": "GEO",
    "iso3166_numeric": "268",
    "currency": "GEL",
    "timezone": "Asia/Tbilisi",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GB",
    "postalCode": "GB",
    "alpha3": "GBR",
    "iso3166_numeric": "826",
    "currency": "GBP",
    "timezone": "Europe/London",
    "zipFormat": "FORMAT_GB",
    "cityFormat": "CITY_ZIP",
    "EUMemberAsOf": "1973-01-01",
    "deactivated": 0,
    "EUMemberUntil": "2020-12-31"
  },
  {
    "code": "BF",
    "postalCode": "BF",
    "alpha3": "BFA",
    "iso3166_numeric": "854",
    "currency": "XOF",
    "timezone": "Africa/Ouagadougou",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KR",
    "postalCode": "ROK",
    "alpha3": "KOR",
    "iso3166_numeric": "410",
    "currency": "KRW",
    "timezone": "Asia/Seoul",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "UM",
    "postalCode": "",
    "alpha3": "UMI",
    "iso3166_numeric": "581",
    "currency": "USD",
    "timezone": "Pacific/Midway",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CX",
    "postalCode": "",
    "alpha3": "CXR",
    "iso3166_numeric": "162",
    "currency": "AUD",
    "timezone": "Indian/Christmas",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TR",
    "postalCode": "TR",
    "alpha3": "TUR",
    "iso3166_numeric": "792",
    "currency": "TRY",
    "timezone": "Asia/Istanbul",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "EE",
    "postalCode": "EST",
    "alpha3": "EST",
    "iso3166_numeric": "233",
    "currency": "EEK",
    "timezone": "Europe/Tallinn",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AQ",
    "postalCode": "",
    "alpha3": "ATA",
    "iso3166_numeric": "010",
    "currency": null,
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ID",
    "postalCode": "RI",
    "alpha3": "IDN",
    "iso3166_numeric": "360",
    "currency": "IDR",
    "timezone": "Asia/Jakarta",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CS",
    "postalCode": "SCG",
    "alpha3": "SCG",
    "iso3166_numeric": "891",
    "currency": "CSD",
    "timezone": "Europe/Belgrade",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 1,
    "EUMemberUntil": null
  },
  {
    "code": "ST",
    "postalCode": "STP",
    "alpha3": "STP",
    "iso3166_numeric": "678",
    "currency": "STD",
    "timezone": "Africa/Sao_Tome",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "WF",
    "postalCode": "",
    "alpha3": "WLF",
    "iso3166_numeric": "876",
    "currency": "XPF",
    "timezone": "Pacific/Wallis",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "UY",
    "postalCode": "ROU",
    "alpha3": "URY",
    "iso3166_numeric": "858",
    "currency": "UYU",
    "timezone": "America/Montevideo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SE",
    "postalCode": "S",
    "alpha3": "SWE",
    "iso3166_numeric": "752",
    "currency": "SEK",
    "timezone": "Europe/Stockholm",
    "zipFormat": "FORMAT_SE",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1995-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NZ",
    "postalCode": "NZ",
    "alpha3": "NZL",
    "iso3166_numeric": "554",
    "currency": "NZD",
    "timezone": "Pacific/Auckland",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "CITY_ZIP",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NI",
    "postalCode": "NIC",
    "alpha3": "NIC",
    "iso3166_numeric": "558",
    "currency": "NIO",
    "timezone": "America/Managua",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "DJ",
    "postalCode": "DJI",
    "alpha3": "DJI",
    "iso3166_numeric": "262",
    "currency": "DJF",
    "timezone": "Africa/Addis_Ababa",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SN",
    "postalCode": "SN",
    "alpha3": "SEN",
    "iso3166_numeric": "686",
    "currency": "XOF",
    "timezone": "Africa/Dakar",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GA",
    "postalCode": "G",
    "alpha3": "GAB",
    "iso3166_numeric": "266",
    "currency": "XAF",
    "timezone": "Africa/Libreville",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "VA",
    "postalCode": "V",
    "alpha3": "VAT",
    "iso3166_numeric": "336",
    "currency": "EUR",
    "timezone": "Europe/Vatican",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AD",
    "postalCode": "AND",
    "alpha3": "AND",
    "iso3166_numeric": "020",
    "currency": "EUR",
    "timezone": "Europe/Andorra",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BY",
    "postalCode": "BY",
    "alpha3": "BLR",
    "iso3166_numeric": "112",
    "currency": "BYR",
    "timezone": "Europe/Minsk",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GQ",
    "postalCode": "GQ",
    "alpha3": "GNQ",
    "iso3166_numeric": "226",
    "currency": "XAF",
    "timezone": "Africa/Malabo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ER",
    "postalCode": "ER",
    "alpha3": "ERI",
    "iso3166_numeric": "232",
    "currency": "ERN",
    "timezone": "Africa/Asmera",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TD",
    "postalCode": "TD",
    "alpha3": "TCD",
    "iso3166_numeric": "148",
    "currency": "XAF",
    "timezone": "Africa/Ndjamena",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PW",
    "postalCode": "PAL",
    "alpha3": "PLW",
    "iso3166_numeric": "585",
    "currency": "USD",
    "timezone": "Pacific/Palau",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NF",
    "postalCode": "",
    "alpha3": "NFK",
    "iso3166_numeric": "574",
    "currency": "AUD",
    "timezone": "Pacific/Noumea",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NU",
    "postalCode": "",
    "alpha3": "NIU",
    "iso3166_numeric": "570",
    "currency": "NZD",
    "timezone": "Pacific/Niue",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SZ",
    "postalCode": "SD",
    "alpha3": "SWZ",
    "iso3166_numeric": "748",
    "currency": "SZL",
    "timezone": "Africa/Mbabane",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MO",
    "postalCode": "",
    "alpha3": "MAC",
    "iso3166_numeric": "446",
    "currency": "MOP",
    "timezone": "Asia/Macao",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MT",
    "postalCode": "M",
    "alpha3": "MLT",
    "iso3166_numeric": "470",
    "currency": "MTL",
    "timezone": "Europe/Malta",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GN",
    "postalCode": "GUI",
    "alpha3": "GIN",
    "iso3166_numeric": "324",
    "currency": "GNF",
    "timezone": "Africa/Conakry",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IN",
    "postalCode": "IND",
    "alpha3": "IND",
    "iso3166_numeric": "356",
    "currency": "INR",
    "timezone": "Asia/Calcutta",
    "zipFormat": "NUMERIC_6",
    "cityFormat": "CITY_STATE_ZIP_OPTIONAL",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "UG",
    "postalCode": "EAU",
    "alpha3": "UGA",
    "iso3166_numeric": "800",
    "currency": "UGX",
    "timezone": "Africa/Kampala",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AF",
    "postalCode": "AFG",
    "alpha3": "AFG",
    "iso3166_numeric": "004",
    "currency": "AFN",
    "timezone": "Asia/Kabul",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LV",
    "postalCode": "LV",
    "alpha3": "LVA",
    "iso3166_numeric": "428",
    "currency": "LVL",
    "timezone": "Europe/Riga",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BE",
    "postalCode": "B",
    "alpha3": "BEL",
    "iso3166_numeric": "056",
    "currency": "EUR",
    "timezone": "Europe/Brussels",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1957-03-25",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IS",
    "postalCode": "IS",
    "alpha3": "ISL",
    "iso3166_numeric": "352",
    "currency": "ISK",
    "timezone": "Atlantic/Reykjavik",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NE",
    "postalCode": "RN",
    "alpha3": "NER",
    "iso3166_numeric": "562",
    "currency": "XOF",
    "timezone": "Africa/Niamey",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LY",
    "postalCode": "LAR",
    "alpha3": "LBY",
    "iso3166_numeric": "434",
    "currency": "LYD",
    "timezone": "Africa/Tripoli",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TJ",
    "postalCode": "TJ",
    "alpha3": "TJK",
    "iso3166_numeric": "762",
    "currency": "TJS",
    "timezone": "Asia/Dushanbe",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GP",
    "postalCode": "",
    "alpha3": "GLP",
    "iso3166_numeric": "312",
    "currency": "EUR",
    "timezone": "America/Santo_Domingo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MC",
    "postalCode": "MC",
    "alpha3": "MCO",
    "iso3166_numeric": "492",
    "currency": "EUR",
    "timezone": "Europe/Monaco",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LU",
    "postalCode": "L",
    "alpha3": "LUX",
    "iso3166_numeric": "442",
    "currency": "EUR",
    "timezone": "Europe/Luxembourg",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1957-03-25",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AN",
    "postalCode": "",
    "alpha3": "ANT",
    "iso3166_numeric": "530",
    "currency": "ANG",
    "timezone": "America/Aruba",
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CU",
    "postalCode": "C",
    "alpha3": "CUB",
    "iso3166_numeric": "192",
    "currency": "CUP",
    "timezone": "America/Havana",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KN",
    "postalCode": "SCN",
    "alpha3": "KNA",
    "iso3166_numeric": "659",
    "currency": "XCD",
    "timezone": "America/St_Kitts",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LC",
    "postalCode": "WL",
    "alpha3": "LCA",
    "iso3166_numeric": "662",
    "currency": "XCD",
    "timezone": "America/St_Lucia",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "DK",
    "postalCode": "DK",
    "alpha3": "DNK",
    "iso3166_numeric": "208",
    "currency": "DKK",
    "timezone": "Europe/Copenhagen",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1973-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NO",
    "postalCode": "N",
    "alpha3": "NOR",
    "iso3166_numeric": "578",
    "currency": "NOK",
    "timezone": "Europe/Oslo",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NA",
    "postalCode": "NAM",
    "alpha3": "NAM",
    "iso3166_numeric": "516",
    "currency": "NAD",
    "timezone": "Africa/Windhoek",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LR",
    "postalCode": "LB",
    "alpha3": "LBR",
    "iso3166_numeric": "430",
    "currency": "LRD",
    "timezone": "Africa/Monrovia",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IR",
    "postalCode": "IR",
    "alpha3": "IRN",
    "iso3166_numeric": "364",
    "currency": "IRR",
    "timezone": "Asia/Tehran",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MK",
    "postalCode": "MK",
    "alpha3": "MKD",
    "iso3166_numeric": "807",
    "currency": "MKD",
    "timezone": "Europe/Skopje",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BJ",
    "postalCode": "BJ",
    "alpha3": "BEN",
    "iso3166_numeric": "204",
    "currency": "XOF",
    "timezone": "Africa/Porto-Novo",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BV",
    "postalCode": "",
    "alpha3": "BVT",
    "iso3166_numeric": "074",
    "currency": "NOK",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GR",
    "postalCode": "GR",
    "alpha3": "GRC",
    "iso3166_numeric": "300",
    "currency": "EUR",
    "timezone": "Europe/Athens",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1981-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CZ",
    "postalCode": "CZ",
    "alpha3": "CZE",
    "iso3166_numeric": "203",
    "currency": "CZK",
    "timezone": "Europe/Prague",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BZ",
    "postalCode": "BH",
    "alpha3": "BLZ",
    "iso3166_numeric": "084",
    "currency": "BZD",
    "timezone": "America/Belize",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MU",
    "postalCode": "MS",
    "alpha3": "MUS",
    "iso3166_numeric": "480",
    "currency": "MUR",
    "timezone": "Indian/Mauritius",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ME",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "EUR",
    "timezone": null,
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AL",
    "postalCode": "AL",
    "alpha3": "ALB",
    "iso3166_numeric": "008",
    "currency": "ALL",
    "timezone": "Europe/Tirane",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GM",
    "postalCode": "WAG",
    "alpha3": "GMB",
    "iso3166_numeric": "270",
    "currency": "GMD",
    "timezone": "Africa/Banjul",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "EH",
    "postalCode": "",
    "alpha3": "ESH",
    "iso3166_numeric": "732",
    "currency": "MAD",
    "timezone": "Africa/Casablanca",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GF",
    "postalCode": "",
    "alpha3": "GUF",
    "iso3166_numeric": "254",
    "currency": "EUR",
    "timezone": "America/Cayenne",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "RO",
    "postalCode": "RO",
    "alpha3": "ROU",
    "iso3166_numeric": "642",
    "currency": "RON",
    "timezone": "Europe/Bucharest",
    "zipFormat": "NUMERIC_6",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2007-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GD",
    "postalCode": "WG",
    "alpha3": "GRD",
    "iso3166_numeric": "308",
    "currency": "XCD",
    "timezone": "America/Grenada",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AI",
    "postalCode": "",
    "alpha3": "AIA",
    "iso3166_numeric": "660",
    "currency": "XCD",
    "timezone": "America/Anguilla",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BD",
    "postalCode": "BD",
    "alpha3": "BGD",
    "iso3166_numeric": "050",
    "currency": "BDT",
    "timezone": "Asia/Dhaka",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "VU",
    "postalCode": "VU",
    "alpha3": "VUT",
    "iso3166_numeric": "548",
    "currency": "VUV",
    "timezone": "Pacific/Efate",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SO",
    "postalCode": "SO",
    "alpha3": "SOM",
    "iso3166_numeric": "706",
    "currency": "SOS",
    "timezone": "Africa/Mogadishu",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KM",
    "postalCode": "COM",
    "alpha3": "COM",
    "iso3166_numeric": "174",
    "currency": "KMF",
    "timezone": "Indian/Comoro",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CL",
    "postalCode": "RCH",
    "alpha3": "CHL",
    "iso3166_numeric": "152",
    "currency": "CLP",
    "timezone": "America/Santiago",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BN",
    "postalCode": "BRU",
    "alpha3": "BRN",
    "iso3166_numeric": "096",
    "currency": "BND",
    "timezone": "Asia/Brunei",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "HU",
    "postalCode": "H",
    "alpha3": "HUN",
    "iso3166_numeric": "348",
    "currency": "HUF",
    "timezone": "Europe/Budapest",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LI",
    "postalCode": "FL",
    "alpha3": "LIE",
    "iso3166_numeric": "438",
    "currency": "CHF",
    "timezone": "Europe/Berlin",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NL",
    "postalCode": "NL",
    "alpha3": "NLD",
    "iso3166_numeric": "528",
    "currency": "EUR",
    "timezone": "Europe/Amsterdam",
    "zipFormat": "FORMAT_NL",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1957-03-25",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AR",
    "postalCode": "RA",
    "alpha3": "ARG",
    "iso3166_numeric": "032",
    "currency": "ARS",
    "timezone": "America/Buenos_Aires",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY_STATE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "EC",
    "postalCode": "EC",
    "alpha3": "ECU",
    "iso3166_numeric": "218",
    "currency": "USD",
    "timezone": "America/Guayaquil",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TK",
    "postalCode": "",
    "alpha3": "TKL",
    "iso3166_numeric": "772",
    "currency": "NZD",
    "timezone": "Pacific/Auckland",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IE",
    "postalCode": "IRL",
    "alpha3": "IRL",
    "iso3166_numeric": "372",
    "currency": "EUR",
    "timezone": "Europe/Belfast",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": "1973-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "VG",
    "postalCode": "BVI",
    "alpha3": "VGB",
    "iso3166_numeric": "092",
    "currency": "USD",
    "timezone": "America/Virgin",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SH",
    "postalCode": "",
    "alpha3": "SHN",
    "iso3166_numeric": "654",
    "currency": "SHP",
    "timezone": "Atlantic/St_Helena",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CC",
    "postalCode": "",
    "alpha3": "CCK",
    "iso3166_numeric": "166",
    "currency": "AUD",
    "timezone": "Indian/Cocos",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BL",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "USD",
    "timezone": null,
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "QA",
    "postalCode": "Q",
    "alpha3": "QAT",
    "iso3166_numeric": "634",
    "currency": "QAR",
    "timezone": "Asia/Qatar",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GW",
    "postalCode": "GUB",
    "alpha3": "GNB",
    "iso3166_numeric": "624",
    "currency": "XOF",
    "timezone": "Africa/Bissau",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "YE",
    "postalCode": "YAR",
    "alpha3": "YEM",
    "iso3166_numeric": "887",
    "currency": "YER",
    "timezone": "Asia/Aden",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "JM",
    "postalCode": "JA",
    "alpha3": "JAM",
    "iso3166_numeric": "388",
    "currency": "JMD",
    "timezone": "America/Jamaica",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CD",
    "postalCode": "RCB",
    "alpha3": "COD",
    "iso3166_numeric": "180",
    "currency": "CDF",
    "timezone": "Africa/Kinshasa",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PR",
    "postalCode": "PR",
    "alpha3": "PRI",
    "iso3166_numeric": "630",
    "currency": "USD",
    "timezone": "America/Puerto_Rico",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KP",
    "postalCode": "KP",
    "alpha3": "PRK",
    "iso3166_numeric": "408",
    "currency": "KPW",
    "timezone": "Asia/Pyongyang",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KY",
    "postalCode": "",
    "alpha3": "CYM",
    "iso3166_numeric": "136",
    "currency": "KYD",
    "timezone": "America/Cayman",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "WS",
    "postalCode": "WS",
    "alpha3": "WSM",
    "iso3166_numeric": "882",
    "currency": "WST",
    "timezone": "Pacific/Apia",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MR",
    "postalCode": "RIM",
    "alpha3": "MRT",
    "iso3166_numeric": "478",
    "currency": "MRO",
    "timezone": "Africa/Nouakchott",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PN",
    "postalCode": "",
    "alpha3": "PCN",
    "iso3166_numeric": "612",
    "currency": "NZD",
    "timezone": "Pacific/Pitcairn",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MH",
    "postalCode": "MH",
    "alpha3": "MHL",
    "iso3166_numeric": "584",
    "currency": "USD",
    "timezone": "Pacific/Kwajalein",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KI",
    "postalCode": "KIR",
    "alpha3": "KIR",
    "iso3166_numeric": "296",
    "currency": "AUD",
    "timezone": "Pacific/Tarawa",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TZ",
    "postalCode": "EAT",
    "alpha3": "TZA",
    "iso3166_numeric": "834",
    "currency": "TZS",
    "timezone": "Africa/Dar_es_Salaam",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MM",
    "postalCode": "MYA",
    "alpha3": "MMR",
    "iso3166_numeric": "104",
    "currency": "MMK",
    "timezone": "Asia/Rangoon",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MP",
    "postalCode": "",
    "alpha3": "MNP",
    "iso3166_numeric": "580",
    "currency": "USD",
    "timezone": "Pacific/Saipan",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CY",
    "postalCode": "CY",
    "alpha3": "CYP",
    "iso3166_numeric": "196",
    "currency": "CYP",
    "timezone": "Europe/Nicosia",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BG",
    "postalCode": "BG",
    "alpha3": "BGR",
    "iso3166_numeric": "100",
    "currency": "BGN",
    "timezone": "Europe/Sofia",
    "zipFormat": "NUMERIC_4",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2007-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TW",
    "postalCode": "RC",
    "alpha3": "TWN",
    "iso3166_numeric": "158",
    "currency": "TWD",
    "timezone": "Asia/Taipei",
    "zipFormat": "FORMAT_TW",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TH",
    "postalCode": "THA",
    "alpha3": "THA",
    "iso3166_numeric": "764",
    "currency": "THB",
    "timezone": "Asia/Bangkok",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MZ",
    "postalCode": "MOZ",
    "alpha3": "MOZ",
    "iso3166_numeric": "508",
    "currency": "MZN",
    "timezone": "Africa/Maputo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GL",
    "postalCode": "GRO",
    "alpha3": "GRL",
    "iso3166_numeric": "304",
    "currency": "DKK",
    "timezone": "America/Godthab",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "RE",
    "postalCode": "RE",
    "alpha3": "REU",
    "iso3166_numeric": "638",
    "currency": "EUR",
    "timezone": "Indian/Reunion",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BS",
    "postalCode": "BS",
    "alpha3": "BHS",
    "iso3166_numeric": "044",
    "currency": "BSD",
    "timezone": "America/Nassau",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "FO",
    "postalCode": "FO",
    "alpha3": "FRO",
    "iso3166_numeric": "234",
    "currency": "DKK",
    "timezone": "Etc/UTC",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MS",
    "postalCode": "",
    "alpha3": "MSR",
    "iso3166_numeric": "500",
    "currency": "XCD",
    "timezone": "America/Antigua",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "EG",
    "postalCode": "ET",
    "alpha3": "EGY",
    "iso3166_numeric": "818",
    "currency": "EGP",
    "timezone": "Africa/Cairo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BO",
    "postalCode": "BOL",
    "alpha3": "BOL",
    "iso3166_numeric": "068",
    "currency": "BOB",
    "timezone": "America/La_Paz",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SD",
    "postalCode": "SUD",
    "alpha3": "SDN",
    "iso3166_numeric": "736",
    "currency": "SDD",
    "timezone": "Africa/Khartoum",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LT",
    "postalCode": "LT",
    "alpha3": "LTU",
    "iso3166_numeric": "440",
    "currency": "LTL",
    "timezone": "Europe/Vilnius",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GT",
    "postalCode": "GCA",
    "alpha3": "GTM",
    "iso3166_numeric": "320",
    "currency": "GTQ",
    "timezone": "America/Guatemala",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SJ",
    "postalCode": "",
    "alpha3": "SJM",
    "iso3166_numeric": "744",
    "currency": "NOK",
    "timezone": "Arctic/Longyearbyen",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "NC",
    "postalCode": "NCL",
    "alpha3": "NCL",
    "iso3166_numeric": "540",
    "currency": "XPF",
    "timezone": "Pacific/Noumea",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "HK",
    "postalCode": "HK",
    "alpha3": "HKG",
    "iso3166_numeric": "344",
    "currency": "HKD",
    "timezone": "Asia/Hong_Kong",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MQ",
    "postalCode": "",
    "alpha3": "MTQ",
    "iso3166_numeric": "474",
    "currency": "EUR",
    "timezone": "America/Santo_Domingo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KW",
    "postalCode": "KWT",
    "alpha3": "KWT",
    "iso3166_numeric": "414",
    "currency": "KWD",
    "timezone": "Asia/Kuwait",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "S-",
    "postalCode": "SK-",
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "XDR",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "XI",
    "postalCode": "GB",
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "GBP",
    "timezone": null,
    "zipFormat": "FORMAT_GB",
    "cityFormat": "CITY_ZIP",
    "EUMemberAsOf": "1973-01-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GS",
    "postalCode": "",
    "alpha3": "SGS",
    "iso3166_numeric": "239",
    "currency": "GBP",
    "timezone": "Atlantic/South_Georgia",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "JO",
    "postalCode": "JOR",
    "alpha3": "JOR",
    "iso3166_numeric": "400",
    "currency": "JOD",
    "timezone": "Asia/Amman",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "FM",
    "postalCode": "FSM",
    "alpha3": "FSM",
    "iso3166_numeric": "583",
    "currency": "USD",
    "timezone": "Pacific/Truk",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SG",
    "postalCode": "SGP",
    "alpha3": "SGP",
    "iso3166_numeric": "702",
    "currency": "SGD",
    "timezone": "Asia/Singapore",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TG",
    "postalCode": "RT",
    "alpha3": "TGO",
    "iso3166_numeric": "768",
    "currency": "XOF",
    "timezone": "Africa/Lome",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AO",
    "postalCode": "ANG",
    "alpha3": "AGO",
    "iso3166_numeric": "024",
    "currency": "AOA",
    "timezone": "Africa/Luanda",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MN",
    "postalCode": "MGL",
    "alpha3": "MNG",
    "iso3166_numeric": "496",
    "currency": "MNT",
    "timezone": "Asia/Ulaanbaatar",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TM",
    "postalCode": "TM",
    "alpha3": "TKM",
    "iso3166_numeric": "795",
    "currency": "TMM",
    "timezone": "Asia/Ashgabat",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PA",
    "postalCode": "PA",
    "alpha3": "PAN",
    "iso3166_numeric": "591",
    "currency": "PAB",
    "timezone": "America/Panama",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "XK",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "EUR",
    "timezone": null,
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AG",
    "postalCode": "AG",
    "alpha3": "ATG",
    "iso3166_numeric": "028",
    "currency": "XCD",
    "timezone": "America/Antigua",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BT",
    "postalCode": "BHT",
    "alpha3": "BTN",
    "iso3166_numeric": "064",
    "currency": "BTN",
    "timezone": "Asia/Thimbu",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LB",
    "postalCode": "RL",
    "alpha3": "LBN",
    "iso3166_numeric": "422",
    "currency": "LBP",
    "timezone": "Asia/Beirut",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ET",
    "postalCode": "ETH",
    "alpha3": "ETH",
    "iso3166_numeric": "231",
    "currency": "ETB",
    "timezone": "Africa/Addis_Ababa",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PK",
    "postalCode": "PK",
    "alpha3": "PAK",
    "iso3166_numeric": "586",
    "currency": "PKR",
    "timezone": "Asia/Karachi",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SK",
    "postalCode": "SK",
    "alpha3": "SVK",
    "iso3166_numeric": "703",
    "currency": "SKK",
    "timezone": "Europe/Bratislava",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GH",
    "postalCode": "GH",
    "alpha3": "GHA",
    "iso3166_numeric": "288",
    "currency": "GHS",
    "timezone": "Africa/Accra",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "DM",
    "postalCode": "WD",
    "alpha3": "DMA",
    "iso3166_numeric": "212",
    "currency": "XCD",
    "timezone": "America/Santo_Domingo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BI",
    "postalCode": "BU",
    "alpha3": "BDI",
    "iso3166_numeric": "108",
    "currency": "BIF",
    "timezone": "Africa/Bujumbura",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "JP",
    "postalCode": "J",
    "alpha3": "JPN",
    "iso3166_numeric": "392",
    "currency": "JPY",
    "timezone": "Asia/Tokyo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "LK",
    "postalCode": "CL",
    "alpha3": "LKA",
    "iso3166_numeric": "144",
    "currency": "LKR",
    "timezone": "Asia/Colombo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MW",
    "postalCode": "MW",
    "alpha3": "MWI",
    "iso3166_numeric": "454",
    "currency": "MWK",
    "timezone": "Africa/Blantyre",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SV",
    "postalCode": "ES",
    "alpha3": "SLV",
    "iso3166_numeric": "222",
    "currency": "SVC",
    "timezone": "America/El_Salvador",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "VC",
    "postalCode": "WV",
    "alpha3": "VCT",
    "iso3166_numeric": "670",
    "currency": "XCD",
    "timezone": "America/Santo_Domingo",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PY",
    "postalCode": "PY",
    "alpha3": "PRY",
    "iso3166_numeric": "600",
    "currency": "PYG",
    "timezone": "America/Asuncion",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KE",
    "postalCode": "EAK",
    "alpha3": "KEN",
    "iso3166_numeric": "404",
    "currency": "KES",
    "timezone": "Africa/Nairobi",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SM",
    "postalCode": "RSM",
    "alpha3": "SMR",
    "iso3166_numeric": "674",
    "currency": "EUR",
    "timezone": "Europe/San_Marino",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "YT",
    "postalCode": "",
    "alpha3": "MYT",
    "iso3166_numeric": "175",
    "currency": "EUR",
    "timezone": "Indian/Mayotte",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "MD",
    "postalCode": "MD",
    "alpha3": "MDA",
    "iso3166_numeric": "498",
    "currency": "MDL",
    "timezone": "Europe/Chisinau",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SL",
    "postalCode": "WAL",
    "alpha3": "SLE",
    "iso3166_numeric": "694",
    "currency": "SLL",
    "timezone": "Africa/Freetown",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "RW",
    "postalCode": "RWA",
    "alpha3": "RWA",
    "iso3166_numeric": "646",
    "currency": "RWF",
    "timezone": "Africa/Kigali",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "KH",
    "postalCode": "K",
    "alpha3": "KHM",
    "iso3166_numeric": "116",
    "currency": "KHR",
    "timezone": "Asia/Phnom_Penh",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CO",
    "postalCode": "CO",
    "alpha3": "COL",
    "iso3166_numeric": "170",
    "currency": "COP",
    "timezone": "America/Bogota",
    "zipFormat": "NUMERIC_6",
    "cityFormat": "CITY_STATE_ZIP_OPTIONAL",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AE",
    "postalCode": "UAE",
    "alpha3": "ARE",
    "iso3166_numeric": "784",
    "currency": "AED",
    "timezone": "Asia/Dubai",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "GY",
    "postalCode": "GUY",
    "alpha3": "GUY",
    "iso3166_numeric": "328",
    "currency": "GYD",
    "timezone": "America/Guyana",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IO",
    "postalCode": "",
    "alpha3": "IOT",
    "iso3166_numeric": "086",
    "currency": "USD",
    "timezone": "Etc/UTC",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "ZW",
    "postalCode": null,
    "alpha3": null,
    "iso3166_numeric": null,
    "currency": "ZWD",
    "timezone": null,
    "zipFormat": "ANY",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PL",
    "postalCode": "PL",
    "alpha3": "POL",
    "iso3166_numeric": "616",
    "currency": "PLN",
    "timezone": "Europe/Warsaw",
    "zipFormat": "FORMAT_PL",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "2004-05-01",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IT",
    "postalCode": "I",
    "alpha3": "ITA",
    "iso3166_numeric": "380",
    "currency": "EUR",
    "timezone": "Europe/Rome",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1957-03-25",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "HN",
    "postalCode": "HN",
    "alpha3": "HND",
    "iso3166_numeric": "340",
    "currency": "HNL",
    "timezone": "America/Tegucigalpa",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "DE",
    "postalCode": "D",
    "alpha3": "DEU",
    "iso3166_numeric": "276",
    "currency": "EUR",
    "timezone": "Europe/Berlin",
    "zipFormat": "NUMERIC_5",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": "1957-03-25",
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CV",
    "postalCode": "CV",
    "alpha3": "CPV",
    "iso3166_numeric": "132",
    "currency": "CVE",
    "timezone": "Atlantic/Cape_Verde",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "VI",
    "postalCode": "",
    "alpha3": "VIR",
    "iso3166_numeric": "850",
    "currency": "USD",
    "timezone": "America/Virgin",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "AZ",
    "postalCode": "AZ",
    "alpha3": "AZE",
    "iso3166_numeric": "031",
    "currency": "AZN",
    "timezone": "Asia/Baku",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IQ",
    "postalCode": "IRQ",
    "alpha3": "IRQ",
    "iso3166_numeric": "368",
    "currency": "IQD",
    "timezone": "Asia/Baghdad",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "BM",
    "postalCode": "",
    "alpha3": "BMU",
    "iso3166_numeric": "060",
    "currency": "BMD",
    "timezone": "Atlantic/Bermuda",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "UA",
    "postalCode": "UA",
    "alpha3": "UKR",
    "iso3166_numeric": "804",
    "currency": "UAH",
    "timezone": "Europe/Kiev",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "PF",
    "postalCode": "",
    "alpha3": "PYF",
    "iso3166_numeric": "258",
    "currency": "XPF",
    "timezone": "America/Port-au-Prince",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TL",
    "postalCode": "TL",
    "alpha3": "TLS",
    "iso3166_numeric": "626",
    "currency": "USD",
    "timezone": "Asia/Dili",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "IL",
    "postalCode": "IL",
    "alpha3": "ISR",
    "iso3166_numeric": "376",
    "currency": "ILS",
    "timezone": "Asia/Jerusalem",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TO",
    "postalCode": "TO",
    "alpha3": "TON",
    "iso3166_numeric": "776",
    "currency": "TOP",
    "timezone": "Pacific/Tongatapu",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "VN",
    "postalCode": "VN",
    "alpha3": "VNM",
    "iso3166_numeric": "704",
    "currency": "VND",
    "timezone": "Asia/Saigon",
    "zipFormat": "NONE",
    "cityFormat": "FREE",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "US",
    "postalCode": "USA",
    "alpha3": "USA",
    "iso3166_numeric": "840",
    "currency": "USD",
    "timezone": null,
    "zipFormat": "FORMAT_US",
    "cityFormat": "FORMAT_US",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "CI",
    "postalCode": "CI",
    "alpha3": "CIV",
    "iso3166_numeric": "384",
    "currency": "XOF",
    "timezone": "Africa/Abidjan",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "TV",
    "postalCode": "TUV",
    "alpha3": "TUV",
    "iso3166_numeric": "798",
    "currency": "AUD",
    "timezone": "Pacific/Funafuti",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  },
  {
    "code": "SB",
    "postalCode": "SOL",
    "alpha3": "SLB",
    "iso3166_numeric": "090",
    "currency": "SBD",
    "timezone": "Pacific/Guadalcanal",
    "zipFormat": "ANY",
    "cityFormat": "ZIP_CITY",
    "EUMemberAsOf": null,
    "deactivated": 0,
    "EUMemberUntil": null
  }
]
